import { useNavigate } from "react-router-dom";
import Classes from "./All.module.css";


const ListComp = (props) => {
    const navigateTo = useNavigate();

    const handleClick = () => {
        navigateTo(props?.pageUrl);
    }

    return (
        <>
            <div className={Classes.list} >
                <div className={Classes.listLeft} >
                    <img src={props?.imageUrl} />
                    <div>
                        <h5 className={Classes.normalText} > {props?.title} </h5>
                        <h5 className={Classes.lightText} >{props?.description}</h5>
                    </div>
                </div>
                <div className={Classes.listRight} >
                    <button className={Classes.activateBtn} onClick={handleClick} > <h5 >Activate </h5> </button>
                </div>
            </div>
        </>
    )
}

export default function All() {

    return (
        <div className={Classes.container}>
            <ListComp
                title="Stripe"
                description="Collect payments for your services."
                imageUrl="/assets/images/stripe.png"
                pageUrl='/integrations/stripe'
            />
            <ListComp
                title="Slack"
                description="Import and export data to slack."
                imageUrl="/assets/images/slack.png"
                pageUrl='/integrations/slack'
            />
            <ListComp
                title="Gmail"
                description="Email clients directly from your dashboard."
                imageUrl="/assets/images/gmail.png"
                pageUrl='/integrations/gmail'
            />
        </div>
    );
}
